import { CustomerLayout } from "~/features/routing-guide/layout/customer-layout.tsx";

export const RoutingGuideCustomerPage = () => <CustomerLayout />;
